import { apiClient } from "@/lib/api";

// Placement-cell workspace
export const createCollege = (payload) => apiClient.post("/campus", payload);
export const getMyCollege = () =>
  apiClient.get("/campus/me", { validateStatus: (s) => (s >= 200 && s < 300) || s === 404 });
export const campusOverview = () => apiClient.get("/campus/overview");
export const campusDashboard = () => apiClient.get("/campus/dashboard");
export const updateCollege = (payload) => apiClient.patch("/campus/me", payload);
export const regenerateInviteCode = () => apiClient.post("/campus/regenerate-code");
export const setCollegeLogo = (logo) => apiClient.put("/campus/logo", { logo });
export const removeCollegeLogo = () => apiClient.delete("/campus/logo");
export const listDepartments = () => apiClient.get("/campus/departments");
export const setDepartments = (departments) => apiClient.put("/campus/departments", { departments });
export const collegeByCode = (invite_code) => apiClient.get(`/public/college/${invite_code}`);
export const listStudents = (branch) => apiClient.get("/campus/students", { params: branch ? { branch } : {} });

// Drives (placement cell)
export const listDrives = () => apiClient.get("/campus/drives");
export const createDrive = (payload) => apiClient.post("/campus/drives", payload);
export const updateDrive = (id, status) => apiClient.patch(`/campus/drives/${id}`, { status });
export const driveApplicants = (id) => apiClient.get(`/campus/drives/${id}/applicants`);
export const updateApplication = (id, status) => apiClient.patch(`/campus/applications/${id}`, { status });
export const shareDrive = (id) => apiClient.post(`/campus/drives/${id}/share`);

// Student 360° + college courses
export const studentProfile = (id) => apiClient.get(`/campus/students/${id}/profile`);
export const listCourses = () => apiClient.get("/campus/courses");
export const addCourse = (payload) => apiClient.post("/campus/courses", payload);
export const deleteCourse = (id) => apiClient.delete(`/campus/courses/${id}`);
export const courseProgress = (id) => apiClient.get(`/campus/courses/${id}/progress`);
export const certificateSettings = () => apiClient.get("/campus/certificate");
export const saveCertificateSettings = (payload) => apiClient.put("/campus/certificate", payload);
export const certificatePreviewUrl = () => `${apiClient.defaults.baseURL}/campus/certificate/preview.png`;
export const myCourses = () => apiClient.get("/campus/my/courses");
export const setMyCourseStatus = (id, status) => apiClient.post(`/campus/my/courses/${id}/status`, { status });
export const purchaseCourse = (id) => apiClient.post(`/campus/my/courses/${id}/purchase`);
export const courseSales = () => apiClient.get("/campus/courses/sales");

// AI placement officer (agent + copilot)
export const agentActions = () => apiClient.get("/campus/agent/actions");
export const agentRun = () => apiClient.post("/campus/agent/run");
export const agentApprove = (id) => apiClient.post(`/campus/agent/actions/${id}/approve`);
export const agentApproveAll = () => apiClient.post("/campus/agent/actions/approve-all");
export const agentDismiss = (id) => apiClient.post(`/campus/agent/actions/${id}/dismiss`);
export const agentAutopilot = (enabled) => apiClient.post("/campus/agent/autopilot", { enabled });
export const copilotAsk = (question) => apiClient.post("/campus/agent/copilot", { question });
export const agentBriefing = () => apiClient.get("/campus/agent/briefing");
export const agentExecute = (type, params = {}) => apiClient.post("/campus/agent/execute", { type, params });

export const lookupCompany = (company_name) => apiClient.post("/campus/leads/lookup", { company_name });
export const enrichLeadEmails = (id) => apiClient.post(`/campus/leads/${id}/enrich-emails`);
export const contactEmail = (id, linkedin_url) => apiClient.post(`/campus/leads/${id}/contacts/email`, { linkedin_url });
export const draftLeadOutreach = (id, linkedin_url) =>
  apiClient.post(`/campus/leads/${id}/draft-outreach`, linkedin_url ? { linkedin_url } : {});

// Recruiter discovery (fresher-hiring leads + HR contacts)
export const listLeads = () => apiClient.get("/campus/leads");
export const refreshLeads = () => apiClient.post("/campus/leads/refresh");
export const findLeadHr = (id) => apiClient.post(`/campus/leads/${id}/find-hr`);
export const addLeadToCrm = (id) => apiClient.post(`/campus/leads/${id}/add-to-crm`);

// Recruiter CRM
export const listRecruiters = () => apiClient.get("/campus/recruiters");
export const addRecruiter = (payload) => apiClient.post("/campus/recruiters", payload);
export const updateRecruiter = (id, payload) => apiClient.patch(`/campus/recruiters/${id}`, payload);
export const deleteRecruiter = (id) => apiClient.delete(`/campus/recruiters/${id}`);

// At-risk interventions
export const nudgeStudents = (student_ids) => apiClient.post("/campus/interventions/nudge", student_ids ? { student_ids } : {});
export const listInterventions = () => apiClient.get("/campus/interventions");

// Team + verification
export const listTeam = () => apiClient.get("/campus/team");
export const inviteMember = (payload) => apiClient.post("/campus/team", payload);
export const removeMember = (user_id) => apiClient.delete(`/campus/team/${user_id}`);
export const verifyStudent = (user_id, verified) => apiClient.post(`/campus/students/${user_id}/verify`, { verified });
export const setPlacementStatus = (user_id, status) => apiClient.post(`/campus/students/${user_id}/placement-status`, { status });
export const updateCollegePolicy = (placement_policy) => apiClient.patch("/campus/me", { placement_policy });

// Announcements
export const createAnnouncement = (payload) => apiClient.post("/campus/announcements", payload);
export const listAnnouncements = () => apiClient.get("/campus/announcements");
export const myAnnouncements = () => apiClient.get("/campus/my/announcements");

// Public recruiter shortlist (no auth)
export const getPublicDrive = (token) => apiClient.get(`/public/drive/${token}`);
export const publicDriveDecision = (token, app_id, action) => apiClient.post(`/public/drive/${token}/decision`, { app_id, action });

// Bulk import + reports + billing
export const importStudents = (students) => apiClient.post("/campus/students/import", { students });
export const campusReports = () => apiClient.get("/campus/reports");
export const collegeBilling = () => apiClient.get("/campus/billing");
export const collegeChangePlan = (plan) => apiClient.post("/campus/billing/change-plan", { plan });

// Company ↔ College hiring bridge
export const companyCampusColleges = () => apiClient.get("/company/campus/colleges");
export const companySendInvite = (payload) => apiClient.post("/company/campus/invites", payload);
export const companyCampusInvites = () => apiClient.get("/company/campus/invites");
export const collegeInvites = () => apiClient.get("/campus/invites");
export const respondInvite = (id, accept) => apiClient.post(`/campus/invites/${id}/respond`, { accept });
export const createDriveTask = (driveId, payload) => apiClient.post(`/campus/drives/${driveId}/tasks`, payload);
export const listDriveTasks = (driveId) => apiClient.get(`/campus/drives/${driveId}/tasks`);
export const taskSubmissions = (taskId) => apiClient.get(`/campus/tasks/${taskId}/submissions`);
export const myTasks = () => apiClient.get("/campus/my/tasks");
export const submitTask = (taskId, payload) => apiClient.post(`/campus/tasks/${taskId}/submit`, payload);

// Student-facing
export const joinCollege = (payload) => apiClient.post("/campus/join", payload);
export const myStanding = () => apiClient.get("/campus/my/standing");
export const myDriveAgent = () => apiClient.get("/campus/my/drive-agent");
export const myDrives = () => apiClient.get("/campus/my/drives");
export const myApplications = () => apiClient.get("/campus/my/applications");
export const applyToDrive = (id) => apiClient.post(`/campus/drives/${id}/apply`);

// Drive assessments (proctored screening tests on drives)
export const driveAssessment = (driveId) => apiClient.get(`/campus/drives/${driveId}/assessment`);
export const saveDriveAssessment = (driveId, payload) => apiClient.post(`/campus/drives/${driveId}/assessment`, payload);
export const driveAssessmentSample = (driveId) => apiClient.get(`/campus/drives/${driveId}/assessment/sample`);
export const driveAssessmentResults = (driveId) => apiClient.get(`/campus/drives/${driveId}/assessment/results`);
export const publishDriveAssessment = (driveId, published) => apiClient.post(`/campus/drives/${driveId}/assessment/publish`, { published });
export const shortlistFromAssessment = (driveId, student_ids) => apiClient.post(`/campus/drives/${driveId}/assessment/shortlist`, { student_ids });
export const myDriveAssessment = (driveId) => apiClient.get(`/campus/my/drives/${driveId}/assessment`);
export const startDriveAssessment = (driveId) => apiClient.post(`/campus/my/drives/${driveId}/assessment/start`);
export const driveAssessmentSnapshot = (driveId, image_b64) => apiClient.post(`/campus/my/drives/${driveId}/assessment/snapshot`, { image_b64 });
export const submitDriveAssessment = (driveId, payload) => apiClient.post(`/campus/my/drives/${driveId}/assessment/submit`, payload);

// Drive Prep (paid past-pattern practice per drive)
export const drivePrepStatus = (driveId) => apiClient.get(`/campus/my/drives/${driveId}/prep`);
export const drivePrepPurchase = (driveId) => apiClient.post(`/campus/my/drives/${driveId}/prep/purchase`);
export const drivePrepStart = (driveId) => apiClient.post(`/campus/my/drives/${driveId}/prep/start`);
export const drivePrepSubmit = (driveId, testId, answers) => apiClient.post(`/campus/my/drives/${driveId}/prep/${testId}/submit`, { answers });

// AI Alumni Network
export const alumniList = (params = {}) => apiClient.get("/campus/alumni", { params });
export const alumniAdd = (alumni) => apiClient.post("/campus/alumni", { alumni });
export const alumniEnrich = (id) => apiClient.post(`/campus/alumni/${id}/enrich`);
export const alumniEnrichAll = () => apiClient.post("/campus/alumni/enrich-all");
export const alumniOutreach = (id, purpose) => apiClient.post(`/campus/alumni/${id}/outreach`, { purpose });
export const alumniDelete = (id) => apiClient.delete(`/campus/alumni/${id}`);

// Licensed seats
export const campusSeats = () => apiClient.get("/campus/seats");
export const setStudentLicense = (studentId, active) =>
  apiClient.post(`/campus/students/${studentId}/license`, { active });
export const requestLicenses = (seats, note) =>
  apiClient.post("/campus/licenses/request", { seats, note });

// Season playbook, weekly digest, recruiter reports
export const playbook = () => apiClient.get("/campus/playbook");
export const takeBaseline = (label) => apiClient.post("/campus/playbook/baseline", { label });
export const digestPreview = () => apiClient.get("/campus/digest/preview");
export const digestSend = () => apiClient.post("/campus/digest/send");
export const digestSettings = (enabled) => apiClient.post("/campus/digest/settings", { enabled });
export const studentReport = (id) => apiClient.get(`/campus/students/${id}/report`);
export const driveReports = (driveId, stage) => apiClient.get(`/campus/drives/${driveId}/reports`, { params: stage ? { stage } : {} });
export const myReport = () => apiClient.get("/campus/my/report");
export const mySeason = () => apiClient.get("/campus/my/season");

// Drive forecasts + recruiter CRM depth
export const forecastPreview = (eligibility, company_name) => apiClient.post("/campus/drives/forecast", { eligibility, company_name });
export const driveForecast = (driveId, refresh = false) => apiClient.get(`/campus/drives/${driveId}/forecast`, { params: refresh ? { refresh: true } : {} });
export const forecastAccuracy = () => apiClient.get("/campus/forecast/accuracy");
export const recruiterPipeline = () => apiClient.get("/campus/recruiters/pipeline");
export const recruiterProfile = (id) => apiClient.get(`/campus/recruiters/${id}/profile`);
export const addRecruiterActivity = (id, payload) => apiClient.post(`/campus/recruiters/${id}/activities`, payload);
export const addRecruiterFollowup = (id, payload) => apiClient.post(`/campus/recruiters/${id}/followups`, payload);
export const doneFollowup = (followupId) => apiClient.post(`/campus/recruiters/followups/${followupId}/done`);
export const draftRecruiterInvite = (id, payload = {}) => apiClient.post(`/campus/recruiters/${id}/draft-invite`, payload);
